/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Credit_LimitInputs */

const vi_customer_credit_limit = /** @type {(inputs: Customer_Credit_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạn mức nợ (VND)`)
};

/**

* @param {Customer_Credit_LimitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_credit_limit = /** @type {((inputs?: Customer_Credit_LimitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Credit_LimitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_credit_limit(inputs)
});